import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect } from 'react';
import { MessageTyping } from './messageTyping';
/** Represents a typing indicator. */
export function Typing({ authors, typing, onShow }) {
    const author = authors[typing.userId];
    useEffect(() => {
        onShow();
    }, []);
    return author ? _jsx(MessageTyping, { author: author }) : null;
}
